import Cookies from 'js-cookie';
import { AuthSession } from '../utils/models';
import { getIsExpired } from '../utils/utilities';

const api = Cookies.withAttributes({ path: '/', expires: 1 });
const sessionKey = 'rsidms-user';

export const MAX_AUTH_DURATION_IN_MINUTES = 2880;

export const storeUserSession = (session: AuthSession) => {
    const data = { value: session, timestamp: Date.now() };
    api.set(sessionKey, JSON.stringify(data));
};

export const removeUserSession = () => {
    api.remove(sessionKey);
};

export const checkUserSessionExpired = () => {
    let result = api.get(sessionKey);
    if (!result) return { session: null, isExpired: true };

    let session = JSON.parse(result);
    let isExpired = getIsExpired(session.timestamp, 'minute', MAX_AUTH_DURATION_IN_MINUTES);

    return { session, isExpired };
};

export const retrieveUserSession = () => {
    let { session, isExpired } = checkUserSessionExpired();
    
    if (!session) {
        return null;
    }
    
    if (isExpired) {
        removeUserSession();
	    window.location.href = "/login";
        
        return null;
    }

    return session.value;
};

const cookieService = {
    storeUserSession,
    retrieveUserSession,
    removeUserSession
};

export default cookieService;